export enum Role {
  DeviceManager = 'device-manager',
  OrganizationManager = 'organization-manager',
  UserManager = 'user-manager',
  UserViewer = 'user-viewer',
  DeviceViewer = 'device-viewer',
  Caregiver = 'caregiver',
}

export interface Org {
  id: string;
  name: string;
  roles?: Role[];
  canCreateCare?: boolean;
  demo?: boolean;
  deactivated?: boolean;
  allowTestModels?: string[];
  useDefaultWebhooks?: boolean;
  measurementCount?: number;
}

export interface AuthUser {
  id: string;
  email: string;
  givenName?: string;
  nickname?: string;
  orgs: Org[];
  selectedOrgs: string[];
  globalRoles?: Role[];
  canCreateCare?: boolean;
  needResetPassword?: boolean;
  globalRolesModeEnabled?: boolean;
}

export const hasOneOfGlobalRoles = (authUser: AuthUser, roles: Role[]) => {
  if (authUser.globalRoles) {
    for (const r of roles) {
      if (authUser.globalRoles.indexOf(r) > -1) {
        return true;
      }
    }
  }
  return false;
};

export const hasOneOfOrgRoles = (
  authUser: AuthUser,
  orgIDs: string[],
  roles: Role[]
) => {
  if (hasOneOfGlobalRoles(authUser, roles)) {
    return true;
  }
  return authUser.orgs
    .filter((o) => orgIDs.includes(o.id))
    .every((o) => o.roles && o.roles.some((r) => roles.includes(r)));
};

export const hasRoleInAnyUsersOrg = (
  authUser: AuthUser,
  roles: Role[],
  orgs: Org[]
) => {
  if (!authUser.orgs) {
    return false;
  }
  for (const r of roles) {
    for (const o of orgs) {
      for (const uo of authUser.orgs) {
        if (o.id === uo.id && uo.roles) {
          for (const ur of uo.roles) {
            if (r === ur) {
              return true;
            }
          }
        }
      }
    }
  }
  return false;
};

export const hasUserOrgAnyRole = (authUser: AuthUser) => {
  if (authUser && authUser.orgs) {
    if (
      authUser.orgs.filter((org) => org.roles && org.roles.length).length > 0
    ) {
      return true;
    } else if (authUser.globalRoles && authUser.globalRoles.length > 0) {
      return true;
    }
  }

  return false;
};

export const isDemoOrg = (authUser: AuthUser) => {
  return authUser.orgs.some(
    (o) => authUser.selectedOrgs.includes(o.id) && o.demo
  );
};

export const hasOneOfRoles = (authUser: AuthUser, roles: Role[]) => {
  if (hasOneOfGlobalRoles(authUser, roles)) {
    return true;
  }
  if (authUser.orgs) {
    for (const o of authUser.orgs) {
      for (const r of roles) {
        if (o.roles && o.roles.indexOf(r) > -1) {
          return true;
        }
      }
    }
  }
};
